<style lang="scss">
@media screen and (min-width: 55rem) {
  .service-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .service {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: auto;
      .service-img {
        width: 60%;
        .service-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
          background-image: url("/media/yintai/homepage-2.jpg");
          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .service-text {
        width: 40%;
        margin-left: 3rem;
        min-height: 10rem;
        margin-top: 3rem;
        .service-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .service-introduction {
          font-size: 1.5rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          margin-top: 0.8rem;
          white-space: nowrap;
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .service-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .service {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: auto;
      .service-img {
        width: 100%;
        .service-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
          background-image: url("/media/yintai/homepage-2.jpg");
          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .service-text {
        width: 100%;
        min-height: 10rem;
        margin-top: 3rem;
        .service-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .service-introduction {
          font-size: 1.5rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          margin-top: 0.8rem;
        }
      }
    }
  }
}
</style>

<template>
  <div class="service-container">
    <div class="service">
      <div class="service-img"><div class="service-img-content"></div></div>
      <div class="service-text">
        <div class="service-title">银泰服务</div>
        <div class="service-introduction">
          为消费者提供一站式体验的高品质服务
        </div>
        <a @click="gotoLocation"><ButtonRed style="margin-top: 2rem"></ButtonRed></a>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/yintai/view/component/ButtonRed";

export default {
  name: "service",
  components: { ButtonRed },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    gotoLocation() {
      document.getElementById("buesiness-container").scrollIntoView();
    },
  },
};
</script>
